import { WorkflowRestrictionToggle } from './WorkflowRestrictionToggle'
import type { RecordGrantSubject } from './useUpdateRecordAccessGrant'
import type { PermissionSetEntity } from '@omnea-digital/authz-model'
import type { ComponentType } from 'react'

type EditableKind = RecordGrantSubject['kind']

export const TAB_BY_KIND = {
  user: 'users-and-groups',
  group: 'users-and-groups',
  role: 'roles',
} as const satisfies Record<EditableKind, string>

export type AccessTab = (typeof TAB_BY_KIND)[EditableKind]

type AccessDialogBehaviour = {
  /** A role grant the endpoint reports on an entity without a `roles` tab is not shown. */
  tabs: readonly AccessTab[]
  recordControl: ComponentType<{ recordId: string }> | null
}

/** What the Manage access dialog offers on each entity, beyond what the authz model decides. */
export const ACCESS_DIALOG_BY_ENTITY: Record<PermissionSetEntity, AccessDialogBehaviour> = {
  request: { tabs: ['users-and-groups'], recordControl: null },
  supplier: { tabs: ['users-and-groups'], recordControl: null },
  agreement: { tabs: ['users-and-groups'], recordControl: null },
  bill: { tabs: ['users-and-groups'], recordControl: null },
  workflow: { tabs: ['users-and-groups', 'roles'], recordControl: WorkflowRestrictionToggle },
}
